import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from 'Components';
import {scheduleList, scheduleListByDesc} from '../../service/inventoryQuery';
import {Button, Col, Row, Input, InputNumber, Cascader, Select, Checkbox, Tooltip, Modal, message, Card} from "antd";
import {openNotice, config} from 'Utils';
import {addShoppingCarList} from "../../service/product";
import {getPro} from "../../service/order";
import {treeList2} from '../../service/org';

const Option = Select.Option;

const {TextArea} = Input;

class ScheduleQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            rows: [],
            total: 0,
            searchInfo: '',
            searchItemDescInfo: '',
            loading: false,
            addLoading: false,
            selectedRowKeysOutside: [],
            btnLoading: false,
            singleAddVisible: false,
            cascaderValue: [],
            tree: [],
            ts_disabled: false,
            ts_checked: false,
            ls_checked: false,
            addRows: [],
            addTotal: 1,
            addSearchObj: {
                s: 10,
                p: 1,
            },
            lastsearch: '',
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.getData = this.getData.bind(this);
        this.reset = this.reset.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeItemDesc = this.onChangeItemDesc.bind(this);
        this.onSubmitItemDesc = this.onSubmitItemDesc.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        var rows = JSON.parse(JSON.stringify(self.state.rows));
        if (rows.length > 50) {
            openNotice('warning', '查询行数不能超过50');
            this.setState({loading: false})
            return;
        }
        var searchRow = [];
        rows.forEach(item => {
            searchRow.push({"itemNum": item.itemNum, "qty": item.qty, "rn": item.rn});
        });
        var dmsTgStock = {};
        dmsTgStock.dmsTgSchedules = searchRow;
        scheduleList(dmsTgStock).then(res => {
            if (res.status) {
                self.setState({total: res.data.total, rows: res.data.list, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    getDataByDesc() {
        const self = this;
        var rows = JSON.parse(JSON.stringify(self.state.rows));
        if (rows.length > 50) {
            openNotice('warning', '查询行数不能超过50');
            this.setState({loading: false})
            return;
        }
        var searchRow = [];
        rows.forEach(item => {
            searchRow.push({"itemDesc": item.itemDesc, "qty": item.qty, "rn": item.rn});
        });
        var dmsTgStock = {};
        dmsTgStock.dmsTgSchedules = searchRow;
        scheduleListByDesc(dmsTgStock).then(res => {
            if (res.status) {
                self.setState({total: res.data.total, rows: res.data.list, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    reset() {
        this.setState({searchInfo: ''});
    }

    onChange = (e) => {
        this.setState({searchInfo: e.target.value});
    }
    onChangeItemDesc = (e) => {
        this.setState({searchItemDescInfo: e.target.value});
    }

    onChangeItem(record, index, value) {
        if (value.target.value.length > 100) {
            return;
        }
        var rows = this.state.rows;
        rows[index].itemNum = value.target.value;
        this.setState({
            rows: rows,
        });
    }

    onChangeQty(record, index, value) {
        var rows = this.state.rows;
        rows[index].qty = value;
        this.setState({rows: rows});
    }

    pageChange() {
    }

    onSubmit() {
        if (this.state.searchInfo == null || this.state.searchInfo == '') {
            openNotice('warning', '请在物料编码批量查询栏里输入物料编码,数量后再做查询');
            return;
        }
        var j = 0;
        this.state.searchInfo.split(/[\n]/).forEach(item => {
            j++;
        });
        if (j > 50) {
            openNotice('warning', '批量查询行数不能超过50');
            return;
        }
        this.setState({rows: [], loading: true, selectedRowKeysOutside: []}, () => {
            var i = 0;
            this.state.searchInfo.split(/[\n]/).forEach(item => {
                var rows = this.state.rows;
                if (item.trim().length > 0) {
                    i++;
                    if (i > 50) {
                        openNotice('warning', '批量查询行数不能超过50');
                        return;
                    }
                    var searchItem;
                    var count = null;
                    if (item.trim().indexOf(',') > 0) {
                        searchItem = item.trim().substr(0, item.trim().indexOf(','));
                        var re = /^[0-9]+$/g;
                        if (re.test(item.trim().substr(item.trim().indexOf(',') + 1))) {
                            count = item.trim().substr(item.trim().indexOf(',') + 1);
                        }
                    } else if (item.trim().indexOf(' ') > 0) {
                        searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                        var re = /^[0-9]+$/g;
                        if (re.test(item.trim().substr(item.trim().indexOf(' ') + 1))) {
                            count = item.trim().substr(item.trim().indexOf(' ') + 1);
                        }
                    } else if (item.trim().indexOf('\t') > 0) {
                        searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                        var re = /^[0-9]+$/g;
                        if (re.test(item.trim().substr(item.trim().indexOf('\t') + 1))) {
                            count = item.trim().substr(item.trim().indexOf('\t') + 1);
                        }
                    } else {
                        searchItem = item.trim();
                        count = 1;
                    }
                    var row = {
                        "itemNum": searchItem,
                        "qty": count,
                        "rn": i
                    }
                    rows.push(row);
                }
            });
            this.getData();
        });
    }

    onSubmitItemDesc() {
        if (this.state.searchItemDescInfo == null || this.state.searchItemDescInfo == '') {
            openNotice('warning', '请在物料描述批量搜索栏里输入后再做查询');
            return;
        }
        var j = 0;
        this.state.searchItemDescInfo.split(/[\n]/).forEach(item => {
            j++;
        });
        if (j > 50) {
            openNotice('warning', '批量查询行数不能超过50');
            return;
        }
        this.setState({rows: [], loading: true, selectedRowKeysOutside: []}, () => {
            var i = 0;
            this.state.searchItemDescInfo.split(/[\n]/).forEach(item => {
                var rows = this.state.rows;
                if (item.trim().length > 0) {
                    i++;
                    if (i > 50) {
                        openNotice('warning', '批量查询行数不能超过50');
                        return;
                    }
                    var row = {
                        "itemDesc": item.trim(),
                        "qty": 1,
                        "rn": i
                    }
                    rows.push(row);
                }
            });
            this.getDataByDesc();
        });
    }


    onSearch() {
        this.setState({loading: true}, () => {
            this.getData();
        })
    }


    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };

    deleteRow = () => {
        const self = this;
        if (self.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请选择非空行');
            return;
        }
        var selectedRowKeys = self.state.selectedRowKeysOutside;
        self.setState({
            ...self.state,
            selectedRowKeys: [],
            rows: self.state.rows.filter(x => selectedRowKeys.indexOf(x.rn) === -1),
        });
    }

    export = () => {
        const self = this;
        var rows = JSON.parse(JSON.stringify(self.state.rows));
        if (rows.length > 50) {
            openNotice('warning', '导出行数不能超过50');
            return;
        }
        var searchRow = [];
        rows.forEach(item => {
            if (item.itemNum != null && item.qty != null) {
                searchRow.push({"itemNum": item.itemNum, "qty": item.qty, "rn": item.rn});
            }
        });
        if (rows.length == 0) {
            openNotice('warning', '请先查询再导出');
            return;
        }
        const encodedInput = encodeURIComponent(JSON.stringify(searchRow));
        let url = `${config.server}/api/v1/dms/tgStock/exportDeliveryTime?exportSchedules=${encodedInput}`;
        window.open(url);
    }

    addShoppingCar = () => {
        const self = this;
        if (self.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请选择非空行');
            return;
        }
        var selectedRowKeys = self.state.selectedRowKeysOutside;
        var rows = self.state.rows.filter(x => selectedRowKeys.includes(x.rn));
        var _arr = [];
        rows.forEach(item => {
            if (item.itemId == null) {
                openNotice('warning', '请先查询，再加入购物车');
                return;
            }
            _arr.push({
                productId: item.itemId,
                channelCode: 'FX',
                count: item.qty == null ? 1 : item.qty
            })
        })
        if (_arr.length > 0) {
            self.setState({btnLoading: true}, () => {
                addShoppingCarList(_arr).then(function (result) {
                    if (result && result.code == 200) {
                        self.setState({btnLoading: false});
                        openNotice('success', '加入购物车成功', '');
                    } else {
                        self.setState({btnLoading: false});
                        openNotice('error', '加入购物车失败', (result && result.message) ? result.message : '');
                    }
                });
            })
        }
    }

    addRow = () => {
        this.setState({singleAddVisible: true});
    }

    singleAddOk = () => {
        this.setState({singleAddVisible: false});
    }

    singleAddCancel = () => {
        this.setState({singleAddVisible: false});
    }

    nameChange = (event) => {
        this.setState({
            name: event.target.value,
        });
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.getSingleAdd();
        }
    };

    getSingleAdd = () => {
        if (this.state.name == '') {
            openNotice('warning', '请输入物料名称或编码');
            return;
        }
        if (this.state.name != this.state.lastsearch) {
            this.state.addSearchObj.p = 1;
            this.state.lastsearch = this.state.name;
        }
        this.setState({addLoading: true});
        getPro({
            channelCode: 'FX',
            customerId: this.state.userData.channelId,
            keyword: this.state.code,
            name: this.state.name,
            stockType: this.state.stockType,
            proDetailType: this.state.proDetailType,
            proDetailName: this.state.proDetailName,
            delisting: this.state.ts_checked,
            historyOpen: this.state.ls_checked,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s,
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    addRows: result.data,
                    addTotal: result.total,
                    addLoading: false,
                });
            } else {
                message.error(result.message);
                this.setState({addLoading: false});
            }
        });
    };

    getTree() {
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code;
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code;
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data,
                });
            } else {
                openNotice('warning', result.message);
            }
        });
    }

    CascaderClick() {
        if (this.state.tree == null || this.state.tree == '') {
            this.getTree();
        }
    }

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    };

    CascaderRender = (label) => {
        return label[label.length - 1];
    };

    CascaderChange = (value, selectedOptions) => {
        if (value.length > 0) {
            this.setState({
                proDetailType: selectedOptions[2].value,
                proDetailName: selectedOptions[2].label,
                cascaderValue: value,
                addSearchObj: {...this.state.addSearchObj, p: 1},
            });
        } else {
            this.setState({proDetailType: '', proDetailName: '', cascaderValue: []});
        }
    };

    stockChange = (value) => {
        switch (value) {
            case '0':
                this.setState({
                    stockType: '库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '1':
                this.setState({
                    stockType: '非库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '2':
                this.setState({
                    stockType: '定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '3':
                this.setState({
                    stockType: '专属定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '4':
                this.setState({
                    stockType: '退市',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            default :
                this.setState({
                    stockType: '',
                    ts_disabled: false,
                    ts_checked: false,
                });
                break;
        }
    }

    tsChange = (e) => {
        this.setState({
            stockType: e.target.checked ? '退市' : '',
            ts_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1},
        });
    };

    lsChange = (e) => {
        this.setState({
            ls_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1},
        });
    };

    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getSingleAdd();
        });
    };

    addSave = (record, index, value) => {
        const self = this;
        var rows = self.state.rows;
        var isAdd = false;
        rows.forEach(item => {
            if (item.itemNum == record.itemNum) {
                isAdd = true;
            }
        })
        if (isAdd) {
            openNotice('warning', '商品已添加', null, 1);
            return;
        }
        var row = {"rn": rows.length + 1, "itemNum": record.itemNum};
        rows.push(row);
        self.setState({rows: rows});
        openNotice('success', '商品添加成功', null, 1);
    };


    render() {
        const {
            rows,
            total,
            loading,
            addLoading,
            searchInfo,
            searchItemDescInfo,
            selectedRowKeysOutside,
            btnLoading,
            singleAddVisible,
            cascaderValue,
            tree,
            ts_disabled,
            ts_checked,
            ls_checked,
            addRows,
            addTotal,
            addSearchObj
        } = this.state;
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total,
                current: 1,//当前页码
                pageSize: total,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 140,
                    render: (text, record, index) => <div><Input maxLength="100"
                                                                 value={text}
                                                                 onChange={this.onChangeItem.bind(this, record, index)}/>
                    </div>
                }, {
                    title: '需求数量',
                    dataIndex: 'qty',
                    width: 120,
                    render: (text, record, index) => <div><InputNumber
                        value={text}
                        onChange={this.onChangeQty.bind(this, record, index)}/></div>
                }, {
                    title: '物料名称',
                    dataIndex: 'itemDesc',
                    render:
                        (text, record, index) => {
                            if (record.stockType == "专属定制") {
                                return '***';
                            } else {
                                return text;
                            }
                        }
                }, {
                    title: '物料类别',
                    dataIndex: 'itemCate'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageUnit'
                }, {
                    title: '面价',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        if (record.stockType == "专属定制") {
                            return '***';
                        } else {
                            return text;
                        }
                    }
                }, {
                    title: '库存属性',
                    dataIndex: 'stockType'
                }, {
                    title: '生产周期',
                    dataIndex: 'productionCycle'
                }, {
                    title: '状态',
                    dataIndex: 'itemStatus'
                }, {
                    title: '库存及预计交期',
                    dataIndex: 'scheduleMessage',
                    render: (text, record, index) => {
                        if (text != null) {
                            const items = text.split('；');
                            return (
                                <div>
                                    {items.map((item, index1) => (
                                        <div key={index1}>
                                            {item}
                                            {index1 < items.length - 1 && <br/>}
                                        </div>
                                    ))}
                                </div>
                            );
                        }
                    }
                }
            ],
            rows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: this.onOutsideSelectChange},
        };

        const addProps = {
            rowKey: 'id',
            loading: addLoading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange,
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 90,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 220,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    width: 60,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null || record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span style={{color: '#d61518', height: 50}}>{'¥' + text}</span>);
                        }
                    },
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType',
                    width: 60,
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    width: 220,
                    render: (text, record, index) => {
                        return <span>{`${record.proBigName}/${record.proMiddleName}/${record.proDetailName}`}</span>;
                    },
                },
                {
                    title: '历史开单量',
                    dataIndex: 'historyCount',
                    width: 70,
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (
                                <span>经公司高层领导决定，对专属定制物料进行全面管控，若有需求，请发起定制申请</span>);
                        } else {
                            return (<Button style={{background: '#red'}} icon="plus"
                                            onClick={this.addSave.bind(this, record, index)}>添加</Button>);
                        }
                    },
                },
            ],
            rows: addRows,
        };

        return <div className="dms-body">
            <DmsTab options={[`交期查询`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <Row>
                        <Col span={8}>
                            <Card title={<div style={{'color': 'black'}}> 批量输入物料编码查询 </div>}
                                  extra={<Button style={{marginRight: 8}} type="primary" icon="search" shape="circle"
                                                 onClick={this.onSubmit}></Button>}
                                  style={{width: 500}}>
                                <Row>
                                    <Col span={24}>
                                        <TextArea rows={4} value={searchInfo}
                                                  placeholder='请按以下格式多行输入物料编码、数量进行库存与交期批量查询：&#10;010110001 50&#10;010110002 10'
                                                  onChange={this.onChange}/>
                                    </Col>
                                </Row>
                                <Row style={{'height': '10'}}>
                                    <Col span={24}></Col>
                                </Row>
                                {/*<Row style={{marginTop: '15px'}}>*/}
                                {/*    <Col span={24} style={{textAlign: 'left'}}>*/}
                                {/*        <Button style={{marginRight: 8}} onClick={this.reset}> 重置 </Button>*/}
                                {/*        <Button style={{marginRight: 8}} type="primary" onClick={this.onSubmit}> 批量查询 </Button>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card title={<div style={{'color': 'black'}}> 批量输入物料描述查询 </div>}
                                  extra={<Button style={{marginRight: 8}} type="primary" icon="search" shape="circle"
                                                 onClick={this.onSubmitItemDesc}></Button>}
                                  style={{width: 500}}>
                                <Row>
                                    <Col span={24}>
                                        <TextArea rows={4} value={searchItemDescInfo}
                                                  placeholder='请按以下格式多行输入物料描述进行库存与交期批量查询：&#10;TGB1N-63 1P C16(祥云3.0)&#10;TGB1N-63 2P C20(祥云3.0)'
                                                  onChange={this.onChangeItemDesc}/>
                                    </Col>
                                </Row>
                                <Row style={{'height': '10'}}>
                                    <Col span={24}></Col>
                                </Row>
                                {/*<Row style={{marginTop: '15px'}}>*/}
                                {/*    <Col span={24} style={{textAlign: 'left'}}>*/}
                                {/*        <Button style={{marginRight: 8}} onClick={this.reset}> 重置 </Button>*/}
                                {/*        <Button style={{marginRight: 8}} type="primary" onClick={this.onSubmit}> 批量查询 </Button>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="dms-table-box">
                <div style={{marginBottom: 8}}>
                    <Button style={{marginRight: 8}} onClick={this.addRow.bind(this)}>新增</Button>
                    <Button style={{marginRight: 8}} onClick={this.deleteRow.bind(this)}>删除</Button>
                    <Button style={{marginRight: 8}} type="primary" onClick={this.onSearch}> 查询 </Button>
                    <Button type="primary" style={{marginRight: 8}}
                            onClick={this.addShoppingCar.bind(this)} loading={btnLoading}>加入购物车</Button>
                    <Button style={{marginRight: 8}}
                            onClick={this.export.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>


            <Modal
                visible={singleAddVisible}
                title={<span>选择物料（支持Enter回车查询，<span
                    style={{color: 'red'}}> 搜索不到产品？请尝试勾选退市产品</span>）</span>}
                onOk={this.singleAddOk}
                onCancel={this.singleAddCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称/编码：</label><Input style={{width: 250}}
                                                                              value={this.state.name}
                                                                              onChange={this.nameChange}
                                                                              onKeyPress={this.keypress}/></Col>
                            <Col span={5}><label>产品分类：</label>
                                <Cascader style={{width: '130px'}} options={tree}
                                          value={cascaderValue}
                                          onChange={this.CascaderChange.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          displayRender={this.CascaderRender.bind(this)}
                                          placeholder=""
                                          popupClassName="popupClass"
                                          showSearch={{filter: this.CascaderFilter}}
                                /></Col>
                            <Col span={4}><label>库存属性：</label>
                                <Select defaultValue="" style={{width: 100}} onChange={this.stockChange}>
                                    <Option value="">全部</Option>
                                    <Option value="0">库存</Option>
                                    <Option value="1">非库存</Option>
                                    <Option value="2">定制</Option>
                                    <Option value="3">专属定制</Option>
                                </Select>
                            </Col>
                            <Col span={2}><Checkbox onChange={this.tsChange}
                                                    disabled={ts_disabled}
                                                    checked={ts_checked}>退市产品</Checkbox></Col>
                            <Col span={3}><Tooltip placement="topLeft"
                                                   title="从您历史一年的开单产品中搜索"
                                                   arrowPointAtCenter><Checkbox onChange={this.lsChange}
                                                                                checked={ls_checked}>历史开单产品</Checkbox></Tooltip></Col>
                            <Col span={2}><Button onClick={this.getSingleAdd}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                </div>
            </Modal>

        </div>
    }
}

export default withRouter(ScheduleQuery);


// WEBPACK FOOTER //
// ./src/routes/inventoryQuery/scheduleList.js